import React, { Component } from 'react';
import css from './WorkOrders.module.scss';
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import moment from "moment";
import axios from "axios";
import {connect} from "react-redux";
import getDateQry from "../../helpers/dateHelpers";
import {SCHEDULABLE_QUERY_TIME_PERIOD} from "../../helpers/timePeriods";
import {Link} from "react-router-dom";
import _ from 'lodash';


/**
 * @class
 *
 * Work Orders page.
 */
const WorkOrders = class extends Component  {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();

    currentDate = moment().format('dddd, MMM Do');
    tomorrowDate = moment().add(1, 'days').format('dddd, MMM Do');
    fieldTeamPost = {
        "limit": 25,
        "skip": 0,
        "fields": [
            "Id",
            "Name"
        ],
        "where": {
            "$or": [
                {
                    "Tech_1__c": this.props.user.apiId
                },
                {
                    "Tech_2__c": this.props.user.apiId
                },
                {
                    "Tech_3__c": this.props.user.apiId
                },
                {
                    "Tech_4__c": this.props.user.apiId
                },
                {
                    "Tech_5__c": this.props.user.apiId
                }
            ]
        }
    };

    // ---------- state: ----------
    state = {
        jobsToday: [],
        jobsTomorrow: [],
        jobsPast: [],
        jobsFuture: []
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        axios.post(
            '/sf/FieldTeam/findNo',
            this.fieldTeamPost,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records
                const ids = data.map(item => item.Id);

                if(ids.length !== 0){
                    // Do not forget to get this fixed.
                    this.getWorkOrders(ids);
                }
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(GET) Error finding field teams:\n', err);
                }
            });
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    getWorkOrders = (crewIds) =>{
        let woPost = {
            "limit": 1000,
            "skip": 0,
            "fields": [
                "Id",
                "Name",
                "Date__c",
                "Start_Time__c",
                "Work_Types__c",
                "Opportunity__c",
                "Opportunity__r.Name",
                "Opportunity__r.City__c",
                "Assigned_Field_Team__c",
                "Assigned_Field_Team_2__c",
                "Safety_Auditor__c"
            ],
            "where": {
                "$or": [
                    {"Assigned_Field_Team__c": { "$in": crewIds },},
                    {"Assigned_Field_Team_2__c": { "$in": crewIds }},
                    {"Safety_Auditor__c": this.props.user.apiId}
                ] 
            },
            "date": {
                ...getDateQry(SCHEDULABLE_QUERY_TIME_PERIOD, 'Date__c')
            }
        };
        
        axios.post(
            '/sf/WorkOrder/findNo',
            woPost,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const workOders = res.data.records
                    .map(job => {
                        let formattedTime = moment.utc(job.Start_Time__c, "HH:mm:ssZ").format("h:mm A");
                        let scheduledTimeFormat;
                        let placeholder = job.Start_Time__c.slice(0, 8);
                        let [time, modifier] = placeholder.split(' ')
                        if(modifier === 'PM'){
                            let number = parseInt(time.split(':'));
                            if(number !== 12){
                                number = number + 12;
                            }

                            scheduledTimeFormat = number + ':00';
                        } else {
                            scheduledTimeFormat = time;
                        }

                        let type;
                        if(crewIds.includes(job.Assigned_Field_Team__c) || crewIds.includes(job.Assigned_Field_Team_2__c)){
                            type = job.Work_Types__c;
                        } else if(job.Safety_Auditor__c === this.props.user.apiId){
                            type = 'Site Safety Audit';
                        }

                        return {
                            Id: job.Id,
                            Name: job.Opportunity__r.Name,
                            City: job.Opportunity__r.City__c,
                            Type: type,
                            ScheduledTime: formattedTime,
                            ScheduledDate: job.Date__c,
                            ScheduledStart: moment(job.Date__c ).format('DD-MM-YYYY') + ' ' + scheduledTimeFormat,
                    };
                    });

                const jobsList = _.orderBy(workOders, ['ScheduledStart'], ['asc']);

                // filter/split data into arrays by given time interval:
                const TODAY = moment();
                const TOMORROW = moment().add(1, 'days');
                const THREE_DAYS_AGO = moment().subtract(3, 'days');
                const FUTURE_FIVE_DAYS = moment().add(5, 'days');

                const jobsToday = jobsList.filter(job => {
                    return moment(job.ScheduledDate)
                        .isSame(TODAY, 'day');
                });

                const jobsTomorrow = jobsList.filter(job => {
                    return moment(job.ScheduledDate)
                        .isSame(TOMORROW, 'day');
                });

                const jobsPast = jobsList.filter(job => {
                    return moment(job.ScheduledDate)
                        .isBetween(THREE_DAYS_AGO, TODAY, 'day', '[)');
                });

                const jobsFuture = jobsList.filter(job => {
                    return moment(job.ScheduledDate)
                        .isBetween(TODAY, FUTURE_FIVE_DAYS, 'day', '()');
                });

                this.setState({
                    jobsToday,
                    jobsTomorrow,
                    jobsPast,
                    jobsFuture
                });
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(GET) Error in Work Orders:\n', err);
                }
            });
    }

    getJobHyperlinkName(job) {
        if(job.Type === 'Site Safety Audit'){
            return <Link to={`/safetyAudit/${job.Id}`}>{job.Name}</Link>
        } else {
            return <Link to={`/workOrders/${job.Id}`}>{job.Name}</Link>
        }
    }

    render() {
        return (
            <div className={css.Scheduled}>
                <SectionHeading heading="Work Orders" />

                <div className="row mt-4">
                    <div className="col-12 col-lg-6">
                        <h2>Today <span>{ this.currentDate }</span></h2>
                        <table className={css.Scheduled__Table}>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>City</th>
                                <th>Start Time</th>
                                <th>Type(s)</th>
                            </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.jobsToday
                                    .map(job => {
                                        return (
                                            <tr key={job.Id}>
                                                <td>{this.getJobHyperlinkName(job)}</td>
                                                <td>{job.City}</td>
                                                <td>{job.ScheduledTime}</td>
                                                <td>{job.Type}</td>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>

                    <div className="col-12 col-lg-6 mt-4 mt-lg-0">
                        <h2>Tomorrow <span>{ this.tomorrowDate }</span></h2>
                        <table className={css.Scheduled__Table}>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>City</th>
                                <th>Start Time</th>
                                <th>Type(s)</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.jobsTomorrow
                                    .map(job => {
                                        return (
                                            <tr key={job.Id}>
                                                <td>{this.getJobHyperlinkName(job)}</td>
                                                <td>{job.City}</td>
                                                <td>{job.ScheduledTime}</td>
                                                <td>{job.Type}</td>
                                            </tr>
                                        );
                                    })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* ----- row 2: ----- */}
                <div className="row mt-4">
                    <div className="col-12 col-lg-6">
                        <h2>Past <span>3 Days</span></h2>
                        <table className={css.Scheduled__TableWithDate}>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>City</th>
                                <th>Date</th>
                                <th>Start Time</th>
                                <th>Type(s)</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.jobsPast
                                    .map(job => {
                                        return (
                                            <tr key={job.Id}>
                                                <td>{this.getJobHyperlinkName(job)}</td>
                                                <td>{job.City}</td>
                                                <td>{moment(job.ScheduledDate).format('MMM D')}</td>
                                                <td>{job.ScheduledTime}</td>
                                                <td>{job.Type}</td>
                                            </tr>
                                        );
                                    })
                            }
                            </tbody>
                        </table>
                    </div>

                    <div className="col-12 col-lg-6 mt-4 mt-lg-0">
                        <h2>Future <span>5 Days</span></h2>
                        <table className={css.Scheduled__TableWithDate}>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>City</th>
                                <th>Date</th>
                                <th>Start Time</th>
                                <th>Type(s)</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.jobsFuture
                                    .map(job => {
                                        return (
                                            <tr key={job.Id}>
                                                <td>{this.getJobHyperlinkName(job)}</td>
                                                <td>{job.City}</td>
                                                <td>{moment(job.ScheduledDate).format('MMM D')}</td>
                                                <td>{job.ScheduledTime}</td>
                                                <td>{job.Type}</td>
                                            </tr>
                                        );
                                    })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
};


// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(WorkOrders);
